module.exports = __webpack_public_path__ + "img/ic_map_hotel_label_5_stars.3ef1b190.svg";